import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

let _initialized = false;

export default function initPipeline() {
  if (_initialized) {
    ScrollTrigger.getAll().forEach(t => t.kill());
  }
  _initialized = true;

  // Initial reveal on scroll
  gsap.utils.toArray(".pip-rows").forEach((rowsEl) => {
    const bars = rowsEl.querySelectorAll(".pip-bar");
    if (!bars.length) return;

    gsap.fromTo(
      bars,
      { "--grow": 0 },
      {
        "--grow": 1,
        duration: 0.9,
        ease: "power2.out",
        stagger: 0.08,
        scrollTrigger: {
          trigger: rowsEl,
          start: "top 80%",
          once: true,
          invalidateOnRefresh: true,
        }
      }
    );
  });

  // === Hover re-grow for the corresponding bar ===
  const menuItems = document.querySelectorAll(".pip-menu-item");

  const reGrow = (barEl) => {
    if (!barEl) return;
    if (barEl._hoverTween) barEl._hoverTween.kill();
    gsap.set(barEl, { "--grow": 0 });
    barEl._hoverTween = gsap.to(barEl, {
      "--grow": 1,
      duration: 0.5,
      ease: "power2.out"
    });
  };

  menuItems.forEach((item) => {
    const idx = item.getAttribute("data-row");
    item.addEventListener("mouseenter", () => {
      const bar = document.querySelector(`.pip-row[data-row="${idx}"] .pip-bar`);
      reGrow(bar);
    });
  });

  // Refresh after layout is settled
  const safeRefresh = () => ScrollTrigger.refresh();
  if (document.fonts?.ready) document.fonts.ready.then(() => setTimeout(safeRefresh, 50));
  if (document.readyState === "complete" || document.readyState === "interactive") {
    requestAnimationFrame(safeRefresh);
  } else {
    document.addEventListener("DOMContentLoaded", () => requestAnimationFrame(safeRefresh), { once: true });
  }
  window.addEventListener("load", () => setTimeout(safeRefresh, 50), { once: true });

  // --- Stack labels above bars on small screens
  const stackLabelsOverBars = () => {
    const isMobile = window.matchMedia("(max-width: 1023px)").matches;

    document.querySelectorAll(".pip-card").forEach(card => {
      const list = card.querySelector(".pip-menu-list");
      const rows = card.querySelectorAll(".pip-row");

      card.querySelectorAll(".pip-label").forEach(el => el.remove());

      if (!isMobile) {
        // restore desktop
        if (list) list.style.removeProperty("display");
        return;
      }

      rows.forEach(row => {
        const idx = row.getAttribute("data-row");
        const src = card.querySelector(`.pip-menu-item[data-row="${idx}"]`);
        if (!src) return;

        const label = src.cloneNode(true);
        label.classList.add("pip-label");
        label.removeAttribute("style");
        row.prepend(label);

        const bar = row.querySelector(".pip-bar");
        ["mouseenter","focus","click"].forEach(ev =>
          label.addEventListener(ev, () => reGrow(bar))
        );
      });

      if (list) list.style.display = "none";
    });
  };

  // run now and on resize
  stackLabelsOverBars();
  window.addEventListener("resize", stackLabelsOverBars);

}
